import { render, staticRenderFns } from "./protocol-dialog.vue?vue&type=template&id=f0c34de6&scoped=true&"
import script from "./protocol-dialog.vue?vue&type=script&lang=js&"
export * from "./protocol-dialog.vue?vue&type=script&lang=js&"
import style0 from "./protocol-dialog.vue?vue&type=style&index=0&id=f0c34de6&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0c34de6",
  null
  
)

export default component.exports